export default __webpack_public_path__ + "media/images/svg/burger-icon-01f4b0b8b816d4e7802fa03a99ef3981.svg";